import { useTranslation } from "react-i18next";
import { Banknote, Landmark } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { Money } from "./Money";
import { localName } from "../../lib/localName";

export const CashboxCard = ({ box, onPick, active }) => {
  const { t, i18n } = useTranslation();
  const Icon = box.kind === "bank" ? Landmark : Banknote;

  return (
    <NeuCard
      className={`cursor-pointer p-5 transition-shadow duration-300 ${active ? "shadow-neu-in" : ""}`}
      data-testid={`cashbox-card-${box.id}`}
      onClick={() => onPick(box)}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-base font-bold">
            {i18n.language === "ar" ? localName(box) : box.name}
          </p>
          <p className="text-[11px] text-muted-foreground">{t(`acct.boxKind.${box.kind}`)}</p>
        </div>
        <Icon className="h-5 w-5 text-primary" />
      </div>
      <Money value={box.balance} currency={box.currency}
             className="mt-4 block text-2xl font-bold"
             testid={`cashbox-balance-${box.id}`} />
      {box.last_move_at ? (
        <p className="mt-1 text-[11px] text-muted-foreground" dir="ltr">
          {t("acct.lastMove")}: {box.last_move_at.slice(0, 10)}
        </p>
      ) : null}
    </NeuCard>
  );
};
